import { render, staticRenderFns } from "./CustomerServiceFaqItem.vue?vue&type=template&id=bb8cd12e&scoped=true&"
import script from "./CustomerServiceFaqItem.vue?vue&type=script&lang=js&"
export * from "./CustomerServiceFaqItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomerServiceFaqItem.vue?vue&type=style&index=0&id=bb8cd12e&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8cd12e",
  null
  
)

export default component.exports